'use strict';

const disassembleISODatePartWithoutDayToParts = (isoDatePart) => {
  const parts = isoDatePart.split("-").map(Number);
  return {
    year: parts[0],
    month: parts[1]
  };
};

module.exports = disassembleISODatePartWithoutDayToParts;
//# sourceMappingURL=disassembleISODatePartWithoutDayToParts.cjs.map
